import { reactive, inject, provide } from 'vue'

export interface HeaderConfig {
  showLogo: boolean
  title: string
  subtitle: string
  icon: string
  iconSize: number
  iconColor: string
  compact: boolean
  customClass: string
}

export interface FooterConfig {
  showMeta: boolean
  customClass: string
  version: string
  buildTime: string
}

// 默认配置
export const defaultHeaderConfig: HeaderConfig = {
  showLogo: false,
  title: '',
  subtitle: '',
  icon: '',
  iconSize: 32,
  iconColor: '#667eea',
  compact: false,
  customClass: ''
}

export const defaultFooterConfig: FooterConfig = {
  showMeta: false,
  customClass: '',
  version: '1.0.0',
  buildTime: '2024-01-01'
}

// 用于布局提供者
export function useLayoutProvider() {
  const headerConfig = reactive<HeaderConfig>({ ...defaultHeaderConfig })
  const footerConfig = reactive<FooterConfig>({ ...defaultFooterConfig })

  const updateHeaderConfig = (config: Partial<HeaderConfig>) => {
    Object.assign(headerConfig, config)
  }

  const updateFooterConfig = (config: Partial<FooterConfig>) => {
    Object.assign(footerConfig, config)
  }

  const resetHeaderConfig = () => {
    Object.assign(headerConfig, defaultHeaderConfig)
  }

  const resetFooterConfig = () => {
    Object.assign(footerConfig, defaultFooterConfig)
  }

  // 提供给子组件
  provide('headerConfig', headerConfig)
  provide('footerConfig', footerConfig)
  provide('updateHeaderConfig', updateHeaderConfig)
  provide('updateFooterConfig', updateFooterConfig)
  provide('resetHeaderConfig', resetHeaderConfig)
  provide('resetFooterConfig', resetFooterConfig)

  return {
    headerConfig,
    footerConfig,
    updateHeaderConfig,
    updateFooterConfig,
    resetHeaderConfig,
    resetFooterConfig
  }
}

// 用于布局消费者
export function useLayout() {
  const headerConfig = inject<HeaderConfig>('headerConfig', reactive({ ...defaultHeaderConfig }))
  const footerConfig = inject<FooterConfig>('footerConfig', reactive({ ...defaultFooterConfig }))
  const updateHeaderConfig = inject<(config: Partial<HeaderConfig>) => void>('updateHeaderConfig', () => {})
  const updateFooterConfig = inject<(config: Partial<FooterConfig>) => void>('updateFooterConfig', () => {})
  const resetHeaderConfig = inject<() => void>('resetHeaderConfig', () => {})
  const resetFooterConfig = inject<() => void>('resetFooterConfig', () => {})

  return {
    headerConfig,
    footerConfig,
    updateHeaderConfig,
    updateFooterConfig,
    resetHeaderConfig,
    resetFooterConfig
  }
}